module.exports = __webpack_public_path__ + "static/media/explore_03.d0bac925.jpg";